// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1ktVA","focado":"OptionSelect_focado__1G_Zs"};